import Component from "../core/Component"
import { distance, closest } from "fastest-levenshtein"
import { triggerEvent } from "../utils/dom"
import debounce from "lodash/debounce"
import { event } from "jquery"

const maildomains = [
    "gmail.com",
    "seznam.cz",
    "email.cz",
    "centrum.cz",
    "tiscali.cz",
    "mail.ru",
    "icloud.com",
    "atlas.cz",
    "yahoo.com",
    "azet.sk",
    "zoznam.sk",
    "centrum.sk",
]

export default class InputEmail extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            input: null,
            error: null,
        }

        this.ref.input = this.element.querySelector("input")

        this.helper = null
        this.showHelperDebounced = debounce(this.showHelper, 500)
        this.checkDebounced = debounce(this.check, 100)
    }

    prepare() {
        if (this.ref.input) {
            this.ref.input.addEventListener("change", this.handleInputChange)
            this.ref.input.addEventListener("input", this.handleInputInput)
            setTimeout(() => {
                this.check(this.ref.input.value)
            }, 0)
        }
    }

    handleInputChange = event => {
        this.checkDebounced(event.target.value)
    }

    handleInputInput = (event) => {
        this.checkDebounced(event.target.value)
    };

    check(value) {
        const [mailname = null, maildomain = null] = value.split("@")
        if (!maildomain) {
            return
        }

        const closestMatch = closest(maildomain, maildomains)
        const dist = distance(maildomain, closestMatch)

        if (dist < 4 && dist > 0) {
            this.showHelperDebounced(
                `Máte na mysli <button type="button">${mailname}@${closestMatch}</button>?`
            )
        } else {
            //autoscroll/focus prohizece na neexistujici button asi
            setTimeout(() => {
                this.hideHelper()
            }, 0)
        }
    }

    showHelper(message) {
        if (!this.helper) {
            this.helper = document.createElement("div")
            this.helper.className = `InputEmail-helper`
            this.helper.addEventListener("click", (event) => {
                if (event.target.tagName.toLowerCase() === "button") {
                    this.ref.input.value = event.target.innerText
                    triggerEvent(this.ref.input, "change")
                    triggerEvent(this.ref.input, "input")
                }
            })
            this.element.appendChild(this.helper)
        }

        this.helper.innerHTML = message
    }

    hideHelper() {
        if (this.helper && this.helper.parentNode) {
            this.helper.parentNode.removeChild(this.helper)
            this.helper = null
        }
    }
}
